import { render, staticRenderFns } from "./Walletsmaster.vue?vue&type=template&id=d654e39a&"
import script from "./Walletsmaster.vue?vue&type=script&lang=js&"
export * from "./Walletsmaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports